export const STATUS_UNINITIALISED = "uninitialised";
export const STATUS_LOADING = "loading";
export const STATUS_LOADED = "loaded";
export const STATUS_FAILED = "failed";

export const isStatusLoading = (status) => status === STATUS_LOADING;
export const isStatusLoaded = (status) => status === STATUS_LOADED;
export const isStatusFailed = (status) => status === STATUS_FAILED;
export const isStatusUninitialised = (status) => status === STATUS_UNINITIALISED;
export const isStatusInit = (status) => !isStatusUninitialised( status );